import { render, staticRenderFns } from "./SMulitpleUpload.vue?vue&type=template&id=6a6aa433&"
import script from "./SMulitpleUpload.vue?vue&type=script&lang=js&"
export * from "./SMulitpleUpload.vue?vue&type=script&lang=js&"
import style0 from "./SMulitpleUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports